export const AllowedUses = [
    "Retail",
    "MSC",
    "Office",
    "Data Center",
    "Call Center",
    "Other"
];